import CurrentUser from 'auth/CurrentUser';
import User from 'entities/User';

export function isFeatureEnabled(feature: string) {
  return CurrentUser.isSignedIn() && CurrentUser.getUser().hasFeature(feature);
}

export function activateFeatureToggle(featureToActivate: string) {
  const user = new User();
  jest.spyOn(CurrentUser, 'isSignedIn').mockReturnValue(true);
  jest.spyOn(CurrentUser, 'getUser').mockReturnValue(user);

  const featureFlagMock = new FeatureFlagMock(user);
  featureFlagMock.activate(featureToActivate);
}

export class FeatureFlagMock {
  user: User;
  activatedFeatures: string[];

  static newForNewUser() {
    const user = new User();
    jest.spyOn(CurrentUser, 'isSignedIn').mockReturnValue(true);
    jest.spyOn(CurrentUser, 'getUser').mockReturnValue(user);
    return new FeatureFlagMock(user);
  }

  constructor(user: User) {
    this.user = user;
    this.activatedFeatures = [];
    this.hasFeature = this.hasFeature.bind(this);

    jest.spyOn(user, 'hasFeature').mockImplementation((feature: string) => {
      return this.hasFeature(feature);
    });
  }

  activate(featureFlag: string) {
    this.activatedFeatures.push(featureFlag);
  }

  hasFeature(featureFlag: string) {
    return this.activatedFeatures.includes(featureFlag);
  }
}
